<template>
  <div>
    <list-render :contentId="contentId" :dealId="dealId" :query="query" @sendParams="sendParams" @setFilterQuery="setFilterQuery" v-if="showType == OPERATION_LIST"></list-render>
    <params-render :contentId="contentId" :dealId="dealId"  @saveCallback="saveCallback" v-else-if="showType == OPERATION_PARAMS"></params-render>
    <iframe-render :contentId="contentId" :dataId="dataId" :dealId="dealId" v-else-if="showType == OPERATION_IFRAME"></iframe-render>
    <!--编辑页面处理 LHT 2017-06-20-->
    <form-render :contentId="contentId" :dealId="dealId" :dataId="dataId" @saveCallback="saveCallback" v-else-if="showType === OPERATION_EDIT || showType === OPERATION_DETAIL" :level='level'></form-render>
    <self-render :iden="iden" v-else-if="showType == OPERATION_SELF"></self-render>
    <deal-group-render :contentId="contentId" :dealId="dealId" :dataId="dataId" v-else-if="showType == OPERATION_DEALGROUP"></deal-group-render>
    <form-render :contentId="contentId" :dealId="dealId" @saveCallback="saveCallback" v-else-if="showType != 0" :level='level'></form-render>
  </div>
</template>

<script>
  import cmsConfig from '../../../config/cmsConfig'
  import formRender from './formRender'
  import listRender from './listRender'
  import iframeRender from './iframeRender'
  import paramsRender from './paramsRender'
  import dealGroupRender from './dealGroupRender'
  import selfRender from './selfRender'

  export default {
    name: 'allRender',
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      },
      dataId: {
        type: Number,
        default() {
          return 0
        }
      },
      showType: {
        type: Number,
        default() {
          return 0
        }
      },
      query: {
        type: Object,
        default() {
          return {}
        }
      },
      iden: {
        type: String,
        default() {
          return ''
        }
      },
      level: {
        type: Number
      }
    },
    methods: {
      saveCallback(isSuccess) {
        this.$emit('saveCallback', isSuccess)
      },
      sendParams(queryArr) {
        this.$emit('sendParams', queryArr)
      },
      setFilterQuery(filterQuery, index) {
        console.log('allRender setFilterQuery = ', _g.s2j(_g.j2s(filterQuery)))
        this.$emit('setFilterQuery', filterQuery, index)
      },
      goback() {
        router.go(-1)
      }
    },
    created() {},
    components: {
      formRender,
      iframeRender,
      listRender,
      paramsRender,
      dealGroupRender,
      selfRender
    },
    mixins: [cmsConfig]
  }
</script>



// WEBPACK FOOTER //
// allRender.vue?7946e049